import styled from 'styled-components'

export const Container = styled.main`
  width: 100vw;
  padding: 2%;
  flex-direction: column;
  display: flex;
  max-width: 62.5rem;
  justify-content: center;

  margin: 2% auto;
  > :last-child {
    background-color: ${({ theme }) => theme.colors.black};
    border-radius: 0.5rem;
    h3 {
      padding: 1.5rem 1rem 0;
    }
    > p {
      padding: 0 1rem 1rem;
    }
  }

  div > p {
    margin-top: 1rem;
  }

  form > h3 {
    font-size: 1.875rem;
    margin-bottom: 1rem;
  }
`
